import { Product } from 'signup-ui-lego-core/constants/Product';
const paidMarketingProducts = [Product.MarketingStarter, Product.MarketingBasic, Product.MarketingPro, Product.MarketingEnterprise];
export const hasMarketing = products => {
  return products.some(product => [...paidMarketingProducts, Product.MarketingFree].includes(product));
};
export const hasMarketingPaid = products => {
  return products.some(product => paidMarketingProducts.includes(product));
};